<dx-popup
    #workflowVendorEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="40%"
    height="45%"
    title="Vendor Edit AAP Workflow #{{ workflowId }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="!loadingVisible"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onEditorShown()"
    (onHidden)="onEditorClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box id="workflowVendorEditorBox" width="100%" height="100%" direction="col" class="editor-box-container">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="col-container">
                        <div class="field-label">
                            Community
                            <sup class="cc-text-required">*</sup>
                        </div>
                        <div class="field-component">
                            <app-multi-column-selector
                                #communitySelector
                                [name]="'Community'"
                                [cssClass]="full - width"
                                [gridSource]="communityGridSource"
                                [boxValue]="communityGridBoxValue"
                                [valueExpr]="'communityId'"
                                [displayExpr]="'displayText'"
                                [columnDef]="communityColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 700 }"
                                [showClearButton]="true"
                                [navigateToCommunity]="true"
                                [placeholder]="'Select Community...'"
                                [showHeaderFilters]="true"
                                (gridSelectionEvent)="onCommunitySelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="row-container">
                        <div class="col-container">
                            <div class="field-label">
                                Payee Type
                                <sup class="cc-text-required">*</sup>
                            </div>
                            <div class="field-component">
                                <dx-radio-group
                                    layout="horizontal"
                                    displayExpr="displayName"
                                    valueExpr="value"
                                    [tabIndex]="-1"
                                    [dataSource]="payeeOptions"
                                    [value]="selectedPayee"
                                    (onValueChanged)="onPayeeTypeChanged($event)"
                                ></dx-radio-group>
                            </div>
                        </div>

                        <div class="icon-button-container">
                            <div class="button-content">
                                <i
                                    title="Show PDF"
                                    class="fa-2x icon-content cc-icon-pdf"
                                    [ngClass]="iconPDF"
                                    (click)="onPdfClick()"
                                ></i>
                            </div>
                            <div *ngIf="!!workflowVendorRaw?.hasNotes" class="button-content">
                                <i
                                    title="AAP Workflow Notes"
                                    class="fa-2x icon-content cc-icon-check"
                                    [ngClass]="iconNotes"
                                    (click)="onWorkflowNotesClick()"
                                ></i>
                            </div>
                            <div *ngIf="!workflowVendorRaw?.hasNotes" class="button-content">
                                <i
                                    title="AAP Workflow Notes"
                                    class="fa-2x icon-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconEmptyNotes"
                                    (click)="onWorkflowNotesClick()"
                                ></i>
                            </div>
                            <div class="button-content">
                                <i
                                    class="fa-2x icon-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    title="AAP Workflow History"
                                    (click)="onWorkflowHistoryClick()"
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="row-container">
                        <div class="payee-container">
                            <div class="field-label">
                                Payee
                                <sup class="cc-text-required">*</sup>
                            </div>
                            <div *ngIf="selectedPayee === 'VENDOR'" class="field-component">
                                <app-multi-column-selector
                                    #vendorPayeeSelector
                                    [name]="'Vendor'"
                                    [cssClass]="'full-width'"
                                    [gridSource]="payeeVendorBoxGridSource"
                                    [boxValue]="payeeVendorGridBoxValue"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 700 }"
                                    [valueExpr]="'vendorCode'"
                                    [displayExpr]="'vendorName'"
                                    [columnDef]="vendorPayeeColumns"
                                    [showClearButton]="true"
                                    [placeholder]="'Search Vendor...'"
                                    (gridSelectionEvent)="onVendorPayeeSelection($event)"
                                ></app-multi-column-selector>
                            </div>
                            <div *ngIf="selectedPayee === 'OWNER'" class="field-component">
                                <app-multi-column-selector
                                    #ownerPayeeSelector
                                    [name]="'Owner'"
                                    [cssClass]="'full-width'"
                                    [gridSource]="payeeOwnerBoxGridSource"
                                    [boxValue]="payeeOwnerGridBoxValue"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 700 }"
                                    [valueExpr]="'customerId'"
                                    [displayExpr]="'ownerName'"
                                    [columnDef]="ownerPayeeColumns"
                                    [showClearButton]="true"
                                    [placeholder]="'Search Owner...'"
                                    (gridSelectionEvent)="onOwnerPayeeSelection($event)"
                                ></app-multi-column-selector>
                            </div>

                            <div *ngIf="selectedPayee === 'COMMUNITY'" class="field-component">
                                <app-multi-column-selector
                                    #communitySelector
                                    [name]="'Community'"
                                    [cssClass]="'full-width'"
                                    [gridSource]="payeeCommunityBoxGridSource"
                                    [boxValue]="payeeCommunityGridBoxValue"
                                    [valueExpr]="'communityId'"
                                    [displayExpr]="'communityName'"
                                    [columnDef]="communityPayeeColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 700 }"
                                    [showClearButton]="true"
                                    [navigateToCommunity]="true"
                                    [placeholder]="'Select Community...'"
                                    [showHeaderFilters]="true"
                                    (gridSelectionEvent)="onCommunityPayeeSelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </div>

                        <div class="refresh-button-container">
                            <div class="button-content">
                                <dx-button
                                    [icon]="iconRefresh"
                                    type="default"
                                    text="Refresh"
                                    (onClick)="onRefreshClick(true)"
                                ></dx-button>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-row-container">
                        <div class="left-button-container">
                            <dx-button
                                [icon]="iconCancel"
                                type="default"
                                text="Cancel"
                                [tabIndex]="-1"
                                (onClick)="onEditorClose()"
                            ></dx-button>
                        </div>

                        <div class="right-button-container">
                            <dx-button
                                [icon]="iconCheck"
                                type="success"
                                text="Save and Return To Status"
                                [tabIndex]="-1"
                                (onClick)="onSaveAndReturnClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-workflow-notes-editor
    *ngIf="showWorkFlowEditorNotesPopUp"
    [workflowId]="workflowVendorRaw?.workflowId"
    [communityId]="workflowVendorRaw?.communityId"
    [hasNotes]="workflowVendorRaw?.hasNotes"
    (closeNotesPopUp)="onWorkflowNotesPopClose($event)"
></app-workflow-notes-editor>

<app-workflow-history
    *ngIf="showWorkFlowEditoryHistoryPopUp"
    [workflowId]="workflowVendorRaw.workflowId"
    [communityId]="workflowVendorRaw.communityId"
    (onClose)="onWorkflowHistoryClose()"
></app-workflow-history>

<dx-load-panel
    [position]="{ of: '#workflowVendorEditorBox' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
